// Spanish translations
const esTranslations = {
  // Navigation
  counterPicker: 'Selector de Counters',
  winRate: 'Tasa de Victoria',
  tierList: 'Lista de Niveles',
  // App.js
  appTitle: 'Selector de Counters de Marvel Rivals',
  loading: 'Cargando datos de Marvel Rivals...',
  gameSettings: 'Configuración de Juego',
  enemyTeam: 'Equipo Enemigo',
  alliedTeam: 'Equipo Aliado',
  clear: 'Limpiar',
  selectEnemyHeroesPrompt: 'Selecciona héroes enemigos para ver recomendaciones de counters',
  dataUpdated: 'Datos actualizados para la versión de Marvel Rivals 20250530',
  counterCalculation: 'La puntuación de mejores héroes se calcula según los counters, el meta, los mapas, el rango y las sinergias que contrarrestan a los enemigos',
  copyright: '© 2025 Marvelrivals.vip - Todos los derechos reservados',
  
  // Disclaimer
  disclaimerTitle: 'Aviso de Desarrollo Temprano',
  disclaimerText: 'Esta aplicación se encuentra actualmente en su fase inicial de desarrollo. Debido al acceso limitado a datos completos de partidas, utilizamos recursos externos para obtener información clave: las estrategias de contrición se obtienen de peakrivals.com y fuentes subjetivas de la comunidad (como plataformas Reddit), los datos y estadísticas de héroes de mrapi.org. Es importante destacar que la información proporcionada aquí no es definitiva y no debe interpretarse como una garantía de victoria. El éxito en las partidas depende finalmente de la comunicación en equipo, la toma de decisiones estratégicas y tu dominio personal con el personaje elegido. Te recomendamos adaptar y ajustar tu enfoque según el contexto dinámico de cada partida.',
  disclaimerButton: 'Entendido',
  showDisclaimer: 'Mostrar Aviso',
  
  // HeroSelection.js
  selectEnemyTeam: 'Seleccionar Equipo Enemigo',
  selectAlliedTeam: 'Seleccionar Equipo Aliado',
  tank: 'Tanque',
  damage: 'Daño',
  support: 'Apoyo',
  vanguard: 'Vanguardia',
  duelist: 'Duelista',
  strategist: 'Estratega',
  
  // BannedHeroes.js
  bannedHeroes: 'Héroes Baneados',
  noBannedHeroesYet: 'Aún no hay héroes baneados. Selecciona héroes abajo para prohibirlos.',
  availableHeroes: 'Héroes Disponibles',
  
  // MapRankSelection.js
  map: 'Mapa',
  anyMap: 'Cualquier Mapa',
  rank: 'Rango',
  anyRank: 'Cualquier Rango',
  
  // CounterDisplay.js
  recommendedCounterPicks: 'Counters Recomendados',
  alternativePicks: 'Selecciones Alternativas',
  countersEnemies: 'Counters',
  counteredBy: 'Countered by',
  metaRank: 'Tier',
  mapBonus: 'Bonus de mapa',
  synergiesWith: 'Sinergia con',
  yes: 'Sí',
  no: 'No',
  alliedTeamRatings: 'Calificaciones del Equipo Aliado',
  and: 'y',
  
  // Tabs
  heroSelection: 'Selección de Héroes',
  bannedHeroesTab: 'Héroes Baneados',
  
  // Language
  language: 'Idioma',
  english: 'Inglés',
  spanish: 'Español',
  
  // Win Rate Page
  heroWinRates: 'Tasas de Victoria de Héroes',
  filterByRole: 'Filtrar por Rol',
  allRoles: 'Todos los Roles',
  hero: 'Héroe',
  role: 'Rol',
  pickRate: 'Tasa de Selección',
  banRate: 'Tasa de Baneo',
  gameMode: 'Modo de Juego',
  quickPlay: 'Partida Rápida',
  competitive: 'Competitivo',
  competitiveRank: 'Rango Competitivo',
  competitiveSummary: 'Todos los Rangos',
  bronze: 'Bronce',
  silver: 'Plata',
  gold: 'Oro',
  platinum: 'Platino',
  diamond: 'Diamante',
  master: 'Maestro',
  grandmaster: 'Gran Maestro',
  celestial: 'Celestial',
  
  // Tier List Page
  heroTierRankings: 'Clasificación de Niveles de Héroes',
  tierListDescription: 'Los héroes están clasificados según su rendimiento actual en el meta.',
  tier: 'Nivel',
  new: 'Nuevo',
  noHeroesInTier: 'No hay héroes en este nivel'
};

export default esTranslations;